module.exports = "/_next/static/images/3ea68c05aef6663fd7547f488630eaf6-card-new.svg.webp";